function getValue(key: string): any {
  if (typeof window === "undefined") return null;
  const value = window.localStorage.getItem(key);
  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch (error) {
    return value;
  }
}

function setValue(key: string, value: any): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(key, JSON.stringify(value));
}

function setTheme(value: any): void {
  setValue("theme", value);
}

function getTheme(): string {
  return getValue("theme") || "dark";
}

export { getValue, setValue, setTheme, getTheme };
